let canvasInstance: HTMLCanvasElement | null = null;
let contextInstance: CanvasRenderingContext2D | null = null;

// Text measurement cache
const CacheSize = 400;
const textMeasurementCache = new Map();

const getCacheKey = (text: string, font: string, letterSpacing: string) => {
  return `${text}::${font}::${letterSpacing}`;
};

export const getCanvasContext = () => {
  if (!canvasInstance) {
    canvasInstance = document.createElement('canvas');
    contextInstance = canvasInstance.getContext('2d');
  }
  return contextInstance;
};

export const measureText = (text: string, font: string, letterSpacing: string) => {
  const cacheKey = getCacheKey(text, font, letterSpacing);

  if (textMeasurementCache.has(cacheKey)) {
    return textMeasurementCache.get(cacheKey);
  }

  const context = getCanvasContext();
  if (!context) {
    return 0;
  }

  context.font = font;
  if ('letterSpacing' in context) {
    context.letterSpacing = letterSpacing;
  }

  const width = context.measureText(text).width;

  if (textMeasurementCache.size > CacheSize) {
    const oldestKey = textMeasurementCache.keys().next().value;
    textMeasurementCache.delete(oldestKey);
  }

  textMeasurementCache.set(cacheKey, width);
  return width;
};

export const clearTextMeasurementCache = () => {
  if (canvasInstance) {
    contextInstance = null;
    canvasInstance = null;
    textMeasurementCache.clear();
  }
};
